<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm_title" id="pagev">Contents</h1>
<h2 class="toc_page1"><a href="#/xhtml/06_Introduction">Introduction</a></h2>
<h2 class="toc_page"><a href="#/xhtml/07_Chapter_001"><span class="toc_hg">Chapter One</span></a><a href="#/xhtml/07_Chapter_001">1914 – Starting Out</a></h2>
<h2 class="toc_page"><span href="#/xhtml/08_Chapter_002" title="Link target outside of Sample"><span class="toc_hg">Chapter Two</span></span><span href="#/xhtml/08_Chapter_002" title="Link target outside of Sample">1915 – The Deepening Conflict</span></h2>
<h2 class="toc_page"><span href="#/xhtml/09_Chapter_003" title="Link target outside of Sample"><span class="toc_hg">Chapter Three</span></span><span href="#/xhtml/09_Chapter_003" title="Link target outside of Sample">1916 – The Realisation</span></h2>
<h2 class="toc_page"><span href="#/xhtml/10_Chapter_004" title="Link target outside of Sample"><span class="toc_hg">Chapter Four</span></span><span href="#/xhtml/10_Chapter_004" title="Link target outside of Sample">1917 – Seeing It Through</span></h2>
<h2 class="toc_page"><span href="#/xhtml/11_Chapter_005" title="Link target outside of Sample"><span class="toc_hg">Chapter Five</span></span><span href="#/xhtml/10_Chapter_004" title="Link target outside of Sample">1918 – The Final Push</span></h2>
<h2 class="toc_page"><span href="#/xhtml/12_Chapter_006" title="Link target outside of Sample"><span class="toc_hg">Chapter Six</span></span><span href="#/xhtml/10_Chapter_004" title="Link target outside of Sample">Red Cross Nurses From The Channel Islands</span></h2>
<h2 class="toc_page"><span href="#/xhtml/13_Chapter_007" title="Link target outside of Sample"><span class="toc_hg">Chapter Seven</span></span><span href="#/xhtml/10_Chapter_004" title="Link target outside of Sample">War Memorials</span></h2>
<h2 class="toc_page"><span href="#/xhtml/14_Chapter_008" title="Link target outside of Sample"><span class="toc_hg">Chapter Eight</span></span><span href="#/xhtml/10_Chapter_004" title="Link target outside of Sample">Those Who Died After The Armistice</span></h2>
<h2 class="toc_page11"><span href="#/xhtml/15_Conclusion" title="Link target outside of Sample">Conclusion</span></h2>
<h2 class="toc_page11"><span href="#/xhtml/16_Sources" title="Link target outside of Sample">Sources</span></h2>
<h2 class="toc_page11"><a href="#/xhtml/02_Abouttheauthor">About the Author</a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?fefb5c42